// extracted by mini-css-extract-plugin
export default {"invoiceNumber":"invoice-overview_invoiceNumber__Y1tuH","container":"invoice-overview_container__2KNoF"};